export const Types = {
  SAVE_LIST_LOCATION : 'SAVE_LIST_LOCATION',
}
